module.exports = __webpack_public_path__ + "static/media/googleWhite.a8d43572.svg";